import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['isPanelCheckbox', 'nahlnPanelFlavoursField']

  // this is the html node, which should have changing values
  get isPanelCheckbox() {
    return this.isPanelCheckboxTarget
  }

  get nahlnPanelFlavoursField() {
    return this.nahlnPanelFlavoursFieldTarget
  }

  displayNahlnPanelFlavours(event) {
    if (this.nahlnPanelFlavoursField.disabled) return
    let currentIsPanelValue = event.target.checked
    if (currentIsPanelValue) {
      this.nahlnPanelFlavoursField.classList.remove('d-none')
    } else {
      this.nahlnPanelFlavoursField.classList.add('d-none')
      // clear and refresh selectpicker on hide
      $('#test_nahln_panel_flavours').selectpicker('val', []).selectpicker('refresh')
    }
  }
}